import { Expose } from "class-transformer";
import StaffRes from "./StaffRes";

export default class LoginRes {
  @Expose() readonly accessToken!: string;
  @Expose() readonly staff!: StaffRes;
}
